import React, { createContext, useState, useContext, useMemo } from 'react';

const LanguageContext = createContext();

// 🔥 Tüm çeviri dosyalarını otomatik olarak topla
const loadAllTranslations = () => {
  const context = require.context('../locales', true, /\.json$/);
  const result = {};

  context.keys().forEach((key) => {
    const path = key.replace('./', ''); // örn: tr/home.json
    const [lang, file] = path.split('/');
    const name = file.replace('.json', '');

    if (!result[lang]) result[lang] = {};
    result[lang][name] = context(key);
  });

  return result;
};

const translations = loadAllTranslations();

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(localStorage.getItem('lang') || 'tr');

  const Localizer = (key, group) => {
    return translations[language]?.[group]?.[key] || key;
  };

  const t = (key, group = 'home') => Localizer(key, group);

  const changeLanguage = (lang) => {
    setLanguage(lang);
    localStorage.setItem('lang', lang);
  };

  const value = useMemo(() => ({
    cult: language,
    t,
    Localizer,
    changeLanguage
  }), [language]);

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);
